export type AutomationAppConfig = {
  packageName: string;
  callbackOrigin: string;
};

export const automationAppConfig: AutomationAppConfig = Object.freeze({
  packageName:
    import.meta.env.VITE_DIRECTAPP_ANDROID_PACKAGE_NAME?.trim() || "",
  callbackOrigin: import.meta.env.VITE_APP_URL?.trim() || "",
});

export function isAutomationAppConfigured() {
  return Boolean(
    typeof __AUTOMATION_APP_BUILD__ !== "undefined" &&
    __AUTOMATION_APP_BUILD__ &&
    automationAppConfig.packageName &&
    automationAppConfig.callbackOrigin,
  );
}
